
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SpecialityFormResponse } from "../../models/dtos";

export const specialityFormsApi = createApi({
  reducerPath: 'specialityFormsApi',
  baseQuery: baseAuthQuery('SpecialityForms'),
  tagTypes: ['SpecialityForm'],
  endpoints: (builder) => ({
    getSpecialityForms: builder.query<ApiResponse<SpecialityFormResponse[]>, void>({
      query: () => "",
      providesTags: ['SpecialityForm'],
    }),
    getSpecialityFormById: builder.query<ApiResponse<SpecialityFormResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SpecialityForm'],
    }),
    updateSpecialityForm: builder.mutation<ApiResponse<SpecialityFormResponse>, Partial<SpecialityFormResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SpecialityForm'],
    }),
    deleteSpecialityForm: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SpecialityForm'],
    }),
  }),
});
